module.exports = __webpack_public_path__ + "static/media/under-16-input-info-2.c1578449.png";